/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { AssetRecord } from './AssetRecord';
import {
    AssetRecordFromJSON,
    AssetRecordFromJSONTyped,
    AssetRecordToJSON,
    instanceOfAssetRecord,
} from './AssetRecord';

/**
 * 
 * @export
 * @interface CompleteAssetUploadResponseContent
 */
export interface CompleteAssetUploadResponseContent {
    /**
     * 
     * @type {AssetRecord}
     * @memberof CompleteAssetUploadResponseContent
     */
    asset: AssetRecord;
}


/**
 * Check if a given object implements the CompleteAssetUploadResponseContent interface.
 */
export function instanceOfCompleteAssetUploadResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    return isInstance;
}

export function CompleteAssetUploadResponseContentFromJSON(json: any): CompleteAssetUploadResponseContent {
    return CompleteAssetUploadResponseContentFromJSONTyped(json, false);
}

export function CompleteAssetUploadResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteAssetUploadResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'asset': AssetRecordFromJSON(json['asset']),
    };
}

export function CompleteAssetUploadResponseContentToJSON(value?: CompleteAssetUploadResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'asset': AssetRecordToJSON(value.asset),
    };
}

